import {
  Activity03HugeIcon,
  AddSquareHugeIcon,
  Airplane02HugeIcon,
  Alert01HugeIcon,
  AlertDiamondHugeIcon,
  AnalysisTextLinkHugeIcon,
  Analytics01HugeIcon,
  Archive02HugeIcon,
  ParagraphBulletsPoint02HugeIcon,
  ComplaintHugeIcon,
  CottageHugeIcon,
  HajjHugeIcon,
  Kaaba01HugeIcon,
  LicenseHugeIcon,
  LicenseThirdPartyHugeIcon,
  Location03HugeIcon,
  ManagerHugeIcon,
  MosqueHugeIcon,
  PolicyHugeIcon,
  RealEstateHugeIcon,
  ScrollHugeIcon,
  SearchAreaHugeIcon,
  SecurityCheckHugeIcon,
  SeoHugeIcon,
  ServiceHugeIcon,
  Settings01HugeIcon,
  SquareArrowDataTransferDiagonalHugeIcon,
  StoreVerifiedHugeIcon,
  UserGroup03HugeIcon,
  UserIdVerificationHugeIcon,
  ValidationApprovalHugeIcon,
  WorkAlertHugeIcon,
  UserUnlock01HugeIcon,
  CampaignsHugeIcon,
  GroupsHugeIcon,
  QuestionHugeIcon,
  Briefcase06HugeIcon,
} from "../../Data/svgIcons";
import usePermissions from "@/utils/hooks/usePermissions";
import { MAKKAH_PERMISSIONS_FULL_NAMES, ROLES } from "@/utils/constants";
import { useMemo } from "react";



export const useMenuItems = () => {
  const { hasPermissionByName, hasAnyPermission } = usePermissions()


  // Icons can be added to menu items - if undefined, pseudo-element styles will be used
  const MakkahMenuItems = useMemo(() => [
    {
      menutitle: "MAKKAH_DASHBOARD",
      Items: [
        hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_planning) && {
          title: "PLANNING_AND_PREPARATION",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_organizers) && {
              title: "ORGANIZERS_AND_CONTRACTS",
              path: `/app/makkah/organizers-and-contracts`,
              type: "link",
              icon: ServiceHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_visas) && {
              title: "VISAS",
              path: `/app/makkah/visas`,
              type: "link",
              icon: ValidationApprovalHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_campaigns) && {
              title: "CAMPAIGNS",
              path: `/app/makkah/arrival-campaign`,
              type: "link",
              icon: CampaignsHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_groups) && {
              title: "GROUPS",
              path: `/app/makkah/groups-upcoming`,
              type: "link",
              icon: GroupsHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_camps) && {
              title: "CAMPS",
              path: `/app/makkah/camps`,
              type: "link",
              icon: CottageHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_compliance) && {
              title: "COMPLIANCE",
              path: `/app/makkah/compliance`,
              type: "link",
              icon: PolicyHugeIcon,
            },
          ].filter(Boolean),
        },
        {
          title: "RECEPTIONـOFـPORTS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([MAKKAH_PERMISSIONS_FULL_NAMES.list_port_reception_cards_from_missions, MAKKAH_PERMISSIONS_FULL_NAMES.list_port_reception_cards_from_nask]) && {
              title: "RECEPTION_MAKKAH",
              path: `/app/makkah/JED/reception`,
              type: "link",
              icon: RealEstateHugeIcon,
            },
          ],
        },
        {
          title: "CENTER_RECEPTION",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasAnyPermission([MAKKAH_PERMISSIONS_FULL_NAMES.list_center_reception_cards_from_ports, MAKKAH_PERMISSIONS_FULL_NAMES.list_center_reception_cards_between_cities]) && {
              title: "CENTER_RECEPTION_MAKKAH_ORGANIZER",
              path: `/app/makkah/JED/center-reception`,
              type: "link",
              icon: RealEstateHugeIcon,
            },
            hasAnyPermission([MAKKAH_PERMISSIONS_FULL_NAMES.list_makkah_reception_manifests, MAKKAH_PERMISSIONS_FULL_NAMES.list_makkah_reception_tafweejs])&&
            { //removed
              title: "NUSUK_RECEPTION_MAKKAH",
              path: `/app/makkah/MED/center-reception`,
              type: "link",
              icon: MosqueHugeIcon,
            },
          ],
        },
        {
          title: "HOUSING_AND_ACCOMMODATIONS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.list_housing) && {
              title: "HOUSING",
              path: `/app/makkah/housing-permits`,
              type: "link",
              icon: LicenseThirdPartyHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.list_housing_contracts) && {
              title: "HOUSING_CONTRACTS",
              path: `/app/makkah/housing-contracts`,
              type: "link",
              icon: ScrollHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.list_house_inspection_examinations) && {
              title: "HOUSING_INSPECTION",
              path: `/app/makkah/housing-inspection`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.list_house_inspection_orders) && {
              title: "HOUSING_INSPECTION_MONITORING",
              path: `/app/makkah/housing-inspection-orders`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_house_inspection_results) && {
              title: "FOLLOW_UP_READINESS_REPORTS",
              path: `/app/makkah/housing-inspection-notes`,
              type: "link",
              icon: SeoHugeIcon,
            },
            //TODO: missing:permission
            {
              title: "HOUSING_INSPECTION_REQUESTS_AND_REPORTS",
              path: `/app/makkah/buildings-not-inspected`,
              type: "link",
              icon: ParagraphBulletsPoint02HugeIcon,
            },
          ],
        },
        {
          title: "PILGRIMS_AND_GROUPS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.list_pilgrim_data) && {
              title: "PILGRIMS",
              path: `/app/makkah/pilgrims`,
              type: "link",
              icon: HajjHugeIcon,
            },
            hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.view_accommodations) && {
              title: "CAMPAIGN_SETTLEMENT",
              path: `/app/makkah/campaign-settlement`,
              type: "link",
              icon: AddSquareHugeIcon,
            },
            {
              title: "GROUP_PILGRIMS_QUERY",
              path: `/app/makkah/group-pilgrims-query`,
              type: "link",
              icon: QuestionHugeIcon,
            },
          ],
        },
        {
          title: "NUSUK_CARDS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "NUSUK_CARDS_NEW_BATCHES",
              path: `/app/makkah/nusuk-cards`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            {
              title: "NUSUK_CARDS_BATCH_RETURNS",
              path: `/app/makkah/nusuk-cards/returns`,
              type: "link",
              icon: SquareArrowDataTransferDiagonalHugeIcon,
            },
            {
              title: "NUSUK_CARDS_INQUIRY",
              path: `/app/makkah/nusuk-cards-inquiry`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            {
              title: "NUSUK_CARDS_REPORTS",
              path: `/app/makkah/nusuk-cards-reports`,
              type: "link",
              icon: ComplaintHugeIcon,
            }
          ],
        },
        {
          title: "REPORTS_AND_INCIDENTS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "INCIDENTS",
              path: `/app/makkah/incidents`,
              type: "link",
              icon: Alert01HugeIcon,
            },
            {
              title: "REPORTS",
              path: `/app/makkah/reports`,
              type: "link",
              icon: WorkAlertHugeIcon,
            },
          ],
        },
        {
          title: "DEPARTURE",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "PILGRIM_DEPARTURE",
              path: `/app/makkah/initial-departure-pilgrims`,
              type: "link",
              icon: Kaaba01HugeIcon,
            },
            {
              title: "CAMPAIGN_DEPARTURE",
              path: `/app/makkah/departure_campaigns`,
              type: "link",
              icon: CampaignsHugeIcon,
            },
            {
              title: "GROUPS_DEPARTURE",
              path: `/app/makkah/departure_groups`,
              type: "link",
              icon: GroupsHugeIcon,
            },
            {
              title: "FLIGHTS",
              path: `/app/makkah/flights`,
              type: "link",
              icon: Airplane02HugeIcon,
            },
            {
              title: "PRIVATE_TRANSPORT_CONTRACTS",
              path: `/app/makkah/private-transport-contracts`,
              type: "link",
              icon: LicenseHugeIcon,
            },
          ],
        },
        {
          title: "REPORTS_AND_STATISTICS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "PILGRIM_REPORTS",
              path: `/app/makkah/pilgrim-reports`,
              type: "link",
              icon: ComplaintHugeIcon,
            },
            {
              title: "CAMPAIGN_AND_GROUP_REPORTS",
              path: `/app/makkah/campaigns-and-groups-reports`,
              type: "link",
              icon: AnalysisTextLinkHugeIcon,
            },
            {
              title: "RECEPTION_AND_ARRIVAL_REPORTS",
              path: `/app/makkah/reception-and-arrival-reports`,
              type: "link",
              icon: SquareArrowDataTransferDiagonalHugeIcon,
            },
            {
              title: "DEPARTURE_RQUEST_REPORTS",
              path: `/app/makkah/departure-reports`,
              type: "link",
              icon: Analytics01HugeIcon,
            },
            {
              title: "HOUSING_REPORTS",
              path: `/app/makkah/housing-reports`,
              type: "link",
              icon: Activity03HugeIcon,
            },
            {
              title: "INCIDENT_AND_REPORT_LOGS",
              path: `/app/makkah/incident-and-report-logs`,
              type: "link",
              icon: AlertDiamondHugeIcon,
            },
            {
              title: "COMPLIANCE_REPORTS",
              path: `/app/makkah/compliance-reports`,
              type: "link",
              icon: ManagerHugeIcon,
            },
            {
              title: "USERS_AND_SERVICE_CENTERS",
              path: `/app/makkah/users-and-service-centers`,
              type: "link",
              icon: UserIdVerificationHugeIcon,
            },
          ],
        },
        {
          title: "SYSTEM_MANAGEMENT",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "SERVICE_CENTERS",
              path: `/app/makkah/service-centers`,
              type: "link",
              icon: Location03HugeIcon,
            },
            hasPermissionByName(ROLES.super_admin) && {
              title: "MASTER_DATA",
              path: `/app/makkah/basic-data/cities`,
              type: "link",
              icon: Settings01HugeIcon,
            },
            hasPermissionByName(ROLES.super_admin) &&
            {
              title: "SYSTEM_SECURITY",
              path: `/app/makkah/system-security`,
              type: "link",
              icon: SecurityCheckHugeIcon,
            },
          ],
        },
        {
          title: "ARCHIVES",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "ARCHIVES",
              path: `/app/makkah/archives`,
              type: "link",
              badge: true,
              active: false,
              icon: Archive02HugeIcon,
            },
          ],
        },
      ].filter(Boolean),
    },
  ], [hasAnyPermission, hasPermissionByName]);

  const MadinaPlatformMenuItems = useMemo(() => [
    {
      menutitle: "MADINA_DASHBOARD",
      Items: [
        {
          title: "MADINA_PLANNING_AND_PREPARATION",
          type: "sub",
          badge: true,
          active: false,
          children: [
            // {
            //   title: "MADINA_ORGANIZERS_AND_CONTRACTS",
            //   path: `/app/madina/organizers-and-contracts`,
            //   type: "link",
            // },
            // {
            //   title: "MADINA_VISAS",
            //   path: `/app/madina/visas`,
            //   type: "link",
            // },
            {
              title: "CAMPAIGNS",
              path: `/app/madina/arrival-campaign`,
              type: "link",
            },
            {
              title: "GROUPS",
              path: `/app/madina/groups-upcoming`,
              type: "link",
            },
            {
              title: "COMPLIANCE",
              path: `/app/madina/compliance`,
              type: "link",
            },
          ],
        },
        {
          title: "RECEPTIONـOFـPORTS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "RECEPTION_MADINAH",
              path: `/app/madina/reception`,
              type: "link",
              icon: MosqueHugeIcon,
            },
            {
              title: "BAGS",
              path: `/app/madina/bags`,
              type: "link",
              icon: Briefcase06HugeIcon,
            },
          ],
        },
        {
          title: "CENTER_RECEPTION",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "CENTER_RECEPTION_MADINAH",
              path: `/app/madina/center-reception`,
              type: "link",
              icon: RealEstateHugeIcon,
            },
          ],
        },
        {
          title: "MADINA_HOUSING_AND_ACCOMMODATIONS",
          type: "sub",
          badge: true,
          active: false,
          // icon: YourIconComponent,
          children: [
            {
              title: "MADINA_HOUSING",
              path: `/app/madina/housing-permits`,
              type: "link",
              icon: LicenseThirdPartyHugeIcon,
            },
            {
              title: "MADINA_HOUSING_CONTRACTS",
              path: `/app/madina/housing-contracts`,
              type: "link",
              icon: ScrollHugeIcon,
            },
            {
              title: "HOUSING_INSPECTION",
              path: `/app/madina/housing-inspection`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            {
              title: "HOUSING_INSPECTION_MONITORING",
              path: `/app/madina/housing-inspection-orders`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            {
              title: "FOLLOW_UP_READINESS_REPORTS",
              path: `/app/madina/housing-inspection-notes`,
              type: "link",
              icon: SeoHugeIcon,
            },
          ],
        },
        {
          title: "PILGRIMS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "PILGRIMS",
              path: `/app/madina/pilgrims`,
              type: "link",
              icon: HajjHugeIcon,
            },
          ],
        },
        {
          title: "NUSUK_CARDS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "NUSUK_CARDS_NEW_BATCHES",
              path: `/app/madina/nusuk-cards`,
              type: "link",
              icon: StoreVerifiedHugeIcon,
            },
            {
              title: "NUSUK_CARDS_BATCH_RETURNS",
              path: `/app/madina/nusuk-cards/returns`,
              type: "link",
              icon: SquareArrowDataTransferDiagonalHugeIcon,
            },
            {
              title: "NUSUK_CARDS_INQUIRY",
              path: `/app/madina/nusuk-cards-inquiry`,
              type: "link",
              icon: SearchAreaHugeIcon,
            },
            {
              title: "NUSUK_CARDS_REPORTS",
              path: `/app/madina/nusuk-cards-reports`,
              type: "link",
              icon: ComplaintHugeIcon,
            }
          ],
        },
        {
          title: "MADINA_REPORTS_AND_INCIDENTS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "MADINA_INCIDENTS",
              path: `/app/madina/incidents`,
              type: "link",
            },
            {
              title: "MADINA_REPORTS",
              path: `/app/madina/reports`,
              type: "link",
            },
          ],
        },
        {
          title: "MADINA_DEPARTURE",
          type: "sub",
          badge: true,
          active: false,
          // children: [
          //   {
          //     title: "MADINA_FLIGHTS",
          //     path: `/app/madina/flights`,
          //     type: "link",
          //   },
          //   {
          //     title: "MADINA_PRIVATE_TRANSPORT_CONTRACTS",
          //     path: `/app/madina/private-transport-contracts`,
          //     type: "link",
          //   },
          //   {
          //     title: "MADINA_PILGRIM_PRELIMINARY_DEPARTURE",
          //     path: `/app/madina/pilgrim-preliminary-departure`,
          //     type: "link",
          //   },
          // ],
          children: [
            {
              title: "PILGRIM_DEPARTURE",
              path: `/app/madina/initial-departure-pilgrims`,
              type: "link",
              icon: Kaaba01HugeIcon,
            },
            {
              title: "CAMPAIGN_DEPARTURE",
              path: `/app/madina/departure_campaigns`,
              type: "link",
              icon: CampaignsHugeIcon,
            },
            {
              title: "GROUPS_DEPARTURE",
              path: `/app/madina/departure_groups`,
              type: "link",
              icon: GroupsHugeIcon,
            },
            {
              title: "FLIGHTS",
              path: `/app/madina/flights`,
              type: "link",
              icon: Airplane02HugeIcon,
            },
            {
              title: "PRIVATE_TRANSPORT_CONTRACTS",
              path: `/app/madina/private-transport-contracts`,
              type: "link",
              icon: LicenseHugeIcon,
            },
          ],
        },
        {
          title: "MADINA_REPORTS_AND_STATISTICS",
          type: "sub",
          badge: true,
          active: false,
          children: [
            {
              title: "PILGRIM_REPORTS",
              path: `/app/madina/pilgrim-reports`,
              type: "link",
            },
            {
              title: "MADINA_CAMPAIGN_AND_GROUP_REPORTS",
              path: `/app/madina/campaigns-and-groups-reports`,
              type: "link",
            },
            {
              title: "MADINA_RECEPTION_AND_ARRIVAL_REPORTS",
              path: `/app/madina/reception-and-arrival-reports`,
              type: "link",
            },
            {
              title: "DEPARTURE_RQUEST_REPORTS",
              path: `/app/madina/departure-reports`,
              type: "link",
            },
            {
              title: "HOUSING_REPORTS",
              path: `/app/madina/housing-reports`,
              type: "link",
            },
            {
              title: "MADINA_INCIDENT_AND_REPORT_LOGS",
              path: `/app/madina/incident-and-report-logs`,
              type: "link",
            },
            {
              title: "MADINA_COMPLIANCE_REPORTS",
              path: `/app/madina/compliance-reports`,
              type: "link",
            },
            {
              title: "MADINA_USERS_AND_SERVICE_CENTERS",
              path: `/app/madina/users-and-service-centers`,
              type: "link",
            },
          ],
        },
        {
          title: "SYSTEM_MANAGEMENT",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasPermissionByName(ROLES.super_admin) &&{
              title: "MASTER_DATA",
              path: `/app/madina/basic-data/cities`,
              type: "link",
              icon: Settings01HugeIcon,
            },
            hasPermissionByName(ROLES.super_admin) &&
            {
              title: "SYSTEM_SECURITY",
              path: `/app/madina/system-security`,
              type: "link",
              icon: SecurityCheckHugeIcon,
            },
          ],
        },
      ],
    },
  ], []);
  const UsersManagementMenuItems = useMemo(() => [
    {
      menutitle: "USERS_DASHBOARD",
      Items: [
        {
          title: "SYSTEM_USERS",
          path: `/app/user_management/users`,
          type: "link",
          icon: UserUnlock01HugeIcon,
        },
        {
          title: "GROUPS",
          path: `/app/user_management/groups`,
          type: "link",
          icon: UserGroup03HugeIcon,
        },
      ],
    },
  ], []);

  const SeasonalRecruitmentMenuItems = useMemo(() => [
    {
      menutitle: "SEASONAL_RECRUITMENT_PLATFORM_SHORT",
      Items: [
        {
          title: "SYSTEM_MANAGEMENT",
          type: "sub",
          badge: true,
          active: false,
          children: [
            hasPermissionByName(ROLES.super_admin) && {
              title: "MASTER_DATA",
              path: `/app/seasonal_hr/basic-data/qualifications`,
              type: "link",
              icon: Settings01HugeIcon,
            },
          ].filter(Boolean),
        },
      ],
    },
  ], [hasPermissionByName]);

  return {
    makkah: MakkahMenuItems,
    user_management: UsersManagementMenuItems,
    madina: MadinaPlatformMenuItems,
    seasonal_hr: SeasonalRecruitmentMenuItems,
  }
};




// Icons can be added to menu items - if undefined, pseudo-element styles will be used
const MakkahMenuItems = [
  {
    menutitle: "MAKKAH_DASHBOARD",
    Items: [
      {
        title: "PLANNING_AND_PREPARATION",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "ORGANIZERS_AND_CONTRACTS",
            path: `/app/makkah/organizers-and-contracts`,
            type: "link",
            icon: ServiceHugeIcon,
          },
          {
            title: "VISAS",
            path: `/app/makkah/visas`,
            type: "link",
            icon: ValidationApprovalHugeIcon,
          },
          {
            title: "CAMPAIGNS",
            path: `/app/makkah/arrival-campaign`,
            type: "link",
            icon: CampaignsHugeIcon,
          },
          {
            title: "GROUPS",
            path: `/app/makkah/groups-upcoming`,
            type: "link",
            icon: GroupsHugeIcon,
          },
          {
            title: "CAMPS",
            path: `/app/makkah/camps`,
            type: "link",
            icon: CottageHugeIcon,
          },
          {
            title: "COMPLIANCE",
            path: `/app/makkah/compliance`,
            type: "link",
            icon: PolicyHugeIcon,
          },
        ],
      },
      {
        title: "RECEPTIONـOFـPORTS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "RECEPTION_MAKKAH",
            path: `/app/makkah/JED/reception`,
            type: "link",
            icon: RealEstateHugeIcon,
          },
        ],
      },
      {
        title: "CENTER_RECEPTION",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "CENTER_RECEPTION_MAKKAH_ORGANIZER",
            path: `/app/makkah/JED/center-reception`,
            type: "link",
            icon: RealEstateHugeIcon,
          },
          { //removed
            title: "NUSUK_RECEPTION_MAKKAH",
            path: `/app/makkah/MED/center-reception`,
            type: "link",
            icon: MosqueHugeIcon,
          },
        ],
      },
      {
        title: "HOUSING_AND_ACCOMMODATIONS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "HOUSING",
            path: `/app/makkah/housing-permits`,
            type: "link",
            icon: LicenseThirdPartyHugeIcon,
          },
          {
            title: "HOUSING_CONTRACTS",
            path: `/app/makkah/housing-contracts`,
            type: "link",
            icon: ScrollHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION",
            path: `/app/makkah/housing-inspection`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION_MONITORING",
            path: `/app/makkah/housing-inspection-orders`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "FOLLOW_UP_READINESS_REPORTS",
            path: `/app/makkah/housing-inspection-notes`,
            type: "link",
            icon: SeoHugeIcon,
          },
          // {
          //   title: "BUILDINGS_NOT_INSPECTED",
          //   path: `/app/makkah/buildings-not-inspected`,
          //   type: "link",
          //   icon: Building03HugeIcon,
          // },
          {
            title: "HOUSING_INSPECTION_REQUESTS_AND_REPORTS",
            path: `/app/makkah/buildings-not-inspected`,
            type: "link",
            icon: ParagraphBulletsPoint02HugeIcon,
          },
        ],
      },
      {
        title: "PILGRIMS_AND_GROUPS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "PILGRIMS",
            path: `/app/makkah/pilgrims`,
            type: "link",
            icon: HajjHugeIcon,
          },
          {
            title: "CAMPAIGN_SETTLEMENT",
            path: `/app/makkah/campaign-settlement`,
            type: "link",
            icon: AddSquareHugeIcon,
          },
          {
            title: "GROUP_PILGRIMS_QUERY",
            path: `/app/makkah/group-pilgrims-query`,
            type: "link",
            icon: QuestionHugeIcon,
          },
        ],
      },
      {
        title: "NUSUK_CARDS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "NUSUK_CARDS_NEW_BATCHES",
            path: `/app/makkah/nusuk-cards`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "NUSUK_CARDS_BATCH_RETURNS",
            path: `/app/makkah/nusuk-cards/returns`,
            type: "link",
            icon: SquareArrowDataTransferDiagonalHugeIcon,
          },
          {
            title: "NUSUK_CARDS_INQUIRY",
            path: `/app/makkah/nusuk-cards-inquiry`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "NUSUK_CARDS_REPORTS",
            path: `/app/makkah/nusuk-cards-reports`,
            type: "link",
            icon: ComplaintHugeIcon,
          }
        ],
      },
      {
        title: "REPORTS_AND_INCIDENTS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "INCIDENTS",
            path: `/app/makkah/incidents`,
            type: "link",
            icon: Alert01HugeIcon,
          },
          {
            title: "REPORTS",
            path: `/app/makkah/reports`,
            type: "link",
            icon: WorkAlertHugeIcon,
          },
        ],
      },
      {
        title: "DEPARTURE",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "PILGRIM_DEPARTURE",
            path: `/app/makkah/initial-departure-pilgrims`,
            type: "link",
            icon: Kaaba01HugeIcon,
          },
          {
            title: "CAMPAIGN_DEPARTURE",
            path: `/app/makkah/departure_campaigns`,
            type: "link",
            icon: CampaignsHugeIcon,
          },
          {
            title: "GROUPS_DEPARTURE",
            path: `/app/makkah/departure_groups`,
            type: "link",
            icon: GroupsHugeIcon,
          },
          {
            title: "FLIGHTS",
            path: `/app/makkah/flights`,
            type: "link",
            icon: Airplane02HugeIcon,
          },
          {
            title: "PRIVATE_TRANSPORT_CONTRACTS",
            path: `/app/makkah/private-transport-contracts`,
            type: "link",
            icon: LicenseHugeIcon,
          },
        ],
      },
      {
        title: "REPORTS_AND_STATISTICS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "PILGRIM_REPORTS",
            path: `/app/makkah/pilgrim-reports`,
            type: "link",
            icon: ComplaintHugeIcon,
          },
          {
            title: "CAMPAIGN_AND_GROUP_REPORTS",
            path: `/app/makkah/campaign-and-group-reports`,
            type: "link",
            icon: AnalysisTextLinkHugeIcon,
          },
          {
            title: "RECEPTION_AND_ARRIVAL_REPORTS",
            path: `/app/makkah/reception-and-arrival-reports`,
            type: "link",
            icon: SquareArrowDataTransferDiagonalHugeIcon,
          },
          {
            title: "DEPARTURE_RQUEST_REPORTS",
            path: `/app/makkah/departure-reports`,
            type: "link",
            icon: Analytics01HugeIcon,
          },
          {
            title: "HOUSING_REPORTS",
            path: `/app/makkah/housing-reports`,
            type: "link",
            icon: Activity03HugeIcon,
          },
          {
            title: "INCIDENT_AND_REPORT_LOGS",
            path: `/app/makkah/incident-and-report-logs`,
            type: "link",
            icon: AlertDiamondHugeIcon,
          },
          {
            title: "COMPLIANCE_REPORTS",
            path: `/app/makkah/compliance-reports`,
            type: "link",
            icon: ManagerHugeIcon,
          },
          {
            title: "USERS_AND_SERVICE_CENTERS",
            path: `/app/makkah/users-and-service-centers`,
            type: "link",
            icon: UserIdVerificationHugeIcon,
          },
        ],
      },
      {
        title: "SYSTEM_MANAGEMENT",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "SERVICE_CENTERS",
            path: `/app/makkah/service-centers`,
            type: "link",
            icon: Location03HugeIcon,
          },
          {
            title: "MASTER_DATA",
            path: `/app/makkah/basic-data/cities`,
            type: "link",
            icon: Settings01HugeIcon,
          },
          {
            title: "SYSTEM_SECURITY",
            path: `/app/makkah/system-security`,
            type: "link",
            icon: SecurityCheckHugeIcon,
          },
        ],
      },
      {
        title: "ARCHIVES",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "ARCHIVES",
            path: `/app/makkah/archives`,
            type: "link",
            badge: true,
            active: false,
            icon: Archive02HugeIcon,
          },
        ],
      },
    ],
  },
];
const MadinaPlatformMenuItems = [
  {
    menutitle: "MADINA_DASHBOARD",
    Items: [
      {
        title: "MADINA_PLANNING_AND_PREPARATION",
        type: "sub",
        badge: true,
        active: false,
        children: [
          // {
          //   title: "MADINA_ORGANIZERS_AND_CONTRACTS",
          //   path: `/app/madina/organizers-and-contracts`,
          //   type: "link",
          // },
          // {
          //   title: "MADINA_VISAS",
          //   path: `/app/madina/visas`,
          //   type: "link",
          // },
          {
            title: "CAMPAIGNS",
            path: `/app/madina/arrival-campaign`,
            type: "link",
          },
          {
            title: "GROUPS",
            path: `/app/madina/groups-upcoming`,
            type: "link",
          },
          {
            title: "COMPLIANCE",
            path: `/app/madina/compliance`,
            type: "link",
          },
        ],
      },
      {
        title: "RECEPTIONـOFـPORTS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "RECEPTION_MADINAH",
            path: `/app/madina/reception`,
            type: "link",
            icon: MosqueHugeIcon,
          },
          {
            title: "BAGS",
            path: `/app/madina/bags`,
            type: "link",
            icon: Briefcase06HugeIcon,
          },
        ],
      },
      {
        title: "CENTER_RECEPTION",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "CENTER_RECEPTION_MADINAH",
            path: `/app/madina/center-reception`,
            type: "link",
            icon: RealEstateHugeIcon,
          },
        ],
      },
      {
        title: "MADINA_HOUSING_AND_ACCOMMODATIONS",
        type: "sub",
        badge: true,
        active: false,
        // icon: YourIconComponent,
        children: [
          {
            title: "MADINA_HOUSING",
            path: `/app/madina/housing-permits`,
            type: "link",
            icon: LicenseThirdPartyHugeIcon,
          },
          {
            title: "MADINA_HOUSING_CONTRACTS",
            path: `/app/madina/housing-contracts`,
            type: "link",
            icon: ScrollHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION",
            path: `/app/madina/housing-inspection`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "HOUSING_INSPECTION_MONITORING",
            path: `/app/madina/housing-inspection-orders`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "FOLLOW_UP_READINESS_REPORTS",
            path: `/app/madina/housing-inspection-notes`,
            type: "link",
            icon: SeoHugeIcon,
          },
        ],
      },
      {
        title: "PILGRIMS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "PILGRIMS",
            path: `/app/madina/pilgrims`,
            type: "link",
            icon: HajjHugeIcon,
          },
        ],
      },
      {
        title: "NUSUK_CARDS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "NUSUK_CARDS_NEW_BATCHES",
            path: `/app/madina/nusuk-cards`,
            type: "link",
            icon: StoreVerifiedHugeIcon,
          },
          {
            title: "NUSUK_CARDS_BATCH_RETURNS",
            path: `/app/madina/nusuk-cards/returns`,
            type: "link",
            icon: SquareArrowDataTransferDiagonalHugeIcon,
          },
          {
            title: "NUSUK_CARDS_INQUIRY",
            path: `/app/madina/nusuk-cards-inquiry`,
            type: "link",
            icon: SearchAreaHugeIcon,
          },
          {
            title: "NUSUK_CARDS_REPORTS",
            path: `/app/madina/nusuk-cards-reports`,
            type: "link",
            icon: ComplaintHugeIcon,
          }
        ],
      },
      {
        title: "MADINA_REPORTS_AND_INCIDENTS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MADINA_INCIDENTS",
            path: `/app/madina/incidents`,
            type: "link",
          },
          {
            title: "MADINA_REPORTS",
            path: `/app/madina/reports`,
            type: "link",
          },
        ],
      },
      {
        title: "MADINA_DEPARTURE",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MADINA_FLIGHTS",
            path: `/app/madina/flights`,
            type: "link",
          },
          {
            title: "MADINA_PRIVATE_TRANSPORT_CONTRACTS",
            path: `/app/madina/private-transport-contracts`,
            type: "link",
          },
          {
            title: "MADINA_PILGRIM_PRELIMINARY_DEPARTURE",
            path: `/app/madina/pilgrim-preliminary-departure`,
            type: "link",
          },
        ],
      },
      {
        title: "MADINA_REPORTS_AND_STATISTICS",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "PILGRIM_REPORTS",
            path: `/app/madina/pilgrim-reports`,
            type: "link",
          },
          {
            title: "MADINA_CAMPAIGN_AND_GROUP_REPORTS",
            path: `/app/madina/campaign-and-group-reports`,
            type: "link",
          },
          {
            title: "MADINA_RECEPTION_AND_ARRIVAL_REPORTS",
            path: `/app/madina/reception-and-arrival-reports`,
            type: "link",
          },
          {
            title: "DEPARTURE_RQUEST_REPORTS",
            path: `/app/madina/departure-reports`,
            type: "link",
          },
          {
            title: "HOUSING_REPORTS",
            path: `/app/madina/housing-reports`,
            type: "link",
          },
          {
            title: "MADINA_INCIDENT_AND_REPORT_LOGS",
            path: `/app/madina/incident-and-report-logs`,
            type: "link",
          },
          {
            title: "MADINA_COMPLIANCE_REPORTS",
            path: `/app/madina/compliance-reports`,
            type: "link",
          },
          {
            title: "MADINA_USERS_AND_SERVICE_CENTERS",
            path: `/app/madina/users-and-service-centers`,
            type: "link",
          },
        ],
      },
      {
        title: "SYSTEM_MANAGEMENT",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MASTER_DATA",
            path: `/app/madina/basic-data/cities`,
            type: "link",
            icon: Settings01HugeIcon,
          },
        ],
      },
    ],
  },
];
const UsersManagementMenuItems = [
  {
    menutitle: "USERS_DASHBOARD",
    Items: [
      {
        title: "SYSTEM_USERS",
        path: `/app/user_management/users`,
        type: "link",
        icon: UserUnlock01HugeIcon,
      },
      {
        title: "GROUPS",
        path: `/app/user_management/groups`,
        type: "link",
        icon: UserGroup03HugeIcon,
      },
    ],
  },
];

const SeasonalRecruitmentMenuItems = [
  {
    menutitle: "SEASONAL_RECRUITMENT_PLATFORM_SHORT",
    Items: [
      {
        title: "SYSTEM_MANAGEMENT",
        type: "sub",
        badge: true,
        active: false,
        children: [
          {
            title: "MASTER_DATA",
            path: `/app/seasonal_hr/basic-data/qualifications`,
            type: "link",
            icon: Settings01HugeIcon,
          },
        ],
      },
    ],
  },
];

export const platformMenuItems = {
  makkah: MakkahMenuItems,
  user_management: UsersManagementMenuItems,
  madina: MadinaPlatformMenuItems,
  seasonal_hr: SeasonalRecruitmentMenuItems,
};



